import { html } from '@/app/helpers/axios-instance';

export const fetchHomePageTemplate = () =>
  html.get(`/static/html/home.html`).then(response => response.data);